import { ArrowLeftOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Button, Flex, Tabs, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import AttendanceIcon from "../../components/icons/AttendanceIcon";
import LeaveRequestIcon from "../../components/icons/LeaveRequestIcon";
import OvertimeIcon from "../../components/icons/OvertimeIcon";
import HrmAttendance from "./HrmAttendance";
import HrmEmployeeInfo from "./HrmEmployeeInfo";
import { HrmLeaveEmployee } from "./HrmLeaveEmployee";
import { HrmOvertimeEmployee } from "./HrmOvertimeEmployee";

const { Text } = Typography;

const HrmEmployeeDetail = () => {
  const STORAGE_TAB = "activeTab";
  const STORAGE_EMP = "emp-tap";
  const { alias } = useParams<{ alias: string }>();
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem(STORAGE_TAB) || "info";
  });

  useEffect(() => {
    const prevEmp = localStorage.getItem(STORAGE_EMP);

    if (prevEmp !== alias) {
      localStorage.setItem(STORAGE_EMP, alias!);
      localStorage.setItem(STORAGE_TAB, "info");
      setActiveTab("info");
    }
  }, [alias]);
  useEffect(() => {
    localStorage.setItem(STORAGE_TAB, activeTab);
  }, [activeTab]);
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-full p-4 rounded-xl">
      <Flex align="center" gap="small" className="mb-6">
        <Flex>
          <Button
            type="default"
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            className="w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
          >
            Quay lại
          </Button>
        </Flex>
      </Flex>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        size="large"
        items={[
          {
            key: "info",
            label: (
              <Flex align="center" gap={8}>
                <InfoCircleOutlined className="text-base" />
                <Text strong>Thông tin</Text>
              </Flex>
            ),
          },
          {
            key: "attendance",
            label: (
              <Flex align="center" gap={8}>
                <AttendanceIcon />
                <Flex vertical gap={0}>
                  <Text strong>Chấm công</Text>
                </Flex>
              </Flex>
            ),
          },
          {
            key: "leave",
            label: (
              <Flex align="center" gap={8}>
                <LeaveRequestIcon />
                <Flex vertical gap={0}>
                  <Text strong>Nghỉ phép</Text>
                </Flex>
              </Flex>
            ),
          },
          {
            key: "overtime",
            label: (
              <Flex align="center" gap={8}>
                <OvertimeIcon />

                <Flex vertical gap={0}>
                  <Text strong>Tăng ca</Text>
                </Flex>
              </Flex>
            ),
          },
        ]}
      />

      <div className="flex-1 flex flex-col">
        {activeTab === "info" && <HrmEmployeeInfo />}
        {activeTab === "attendance" && <HrmAttendance />}
        {activeTab === "leave" && <HrmLeaveEmployee />}
        {activeTab === "overtime" && <HrmOvertimeEmployee />}
      </div>
    </div>
  );
};

export default HrmEmployeeDetail;
